import "core-js/modules/es6.number.constructor";
import "core-js/modules/es6.regexp.replace";
import { getQiNiuLazyImg } from '@ykz/ykz-util/platform';
export default {
  name: 'normal-item',
  props: {
    item: {
      default: null
    },
    inPreview: {
      default: true
    }
  },
  data: function data() {
    return {};
  },
  filters: {
    _showAddress: function _showAddress(value) {
      value = value.replace(/(市*$)|(街道*$)|(县*$)/g, "");
      if (value.length > 4) {
        value = value.substring(0, 4);
      }
      return value;
    },
    _showBusiness: function _showBusiness(value) {
      if (value && value.length > 8) {
        value = value.substring(0, 8);
      }
      return value ? '-' + value : '';
    },
    _showMarketPrice: function _showMarketPrice(value) {
      if (String(value).length > 5) {
        return parseInt(value);
      }
      return Number(value || '');
    }
  },
  methods: {
    showCountDown: function showCountDown(item) {
      return Number(item.earnInt || '') < 1000 && Number(item.priceInt || '') < 10000;
    },
    //图片懒加载
    getLazyImg: function getLazyImg(img, stage) {
      return getQiNiuLazyImg(img, stage);
    }
  }
};